import PowerBIReporting from './PowerBIReporting.vue';

export const powerBiReportingRoutes = [
  {
    path: 'power-bi-reporting',
    name: 'power-bi-reporting',
    component: PowerBIReporting,
  }];
